import styled from 'styled-components';
import { hexToRGB } from 'utils';

export const Container = styled.footer`
  background-color: ${({ theme }) => theme.colors.secondary900};
`;

export const Wrap = styled.div`
  max-width: 1600px;
  width: 100%;
  margin: 0 auto;
  padding: 40px 104px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${({ theme }) => theme.device.tablet} {
    padding: 40px 104px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 40px 32px;
  }
`;

export const LogoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column-reverse;
    align-items: unset;
    gap: 32px;
  }
`;

export const SnsBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media ${({ theme }) => theme.device.mobile} {
    justify-content: flex-end;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${({ theme }) => theme.device.tablet} {
    flex-direction: column;
    gap: 40px;
  }
`;

export const InfoBox = styled.div`
  flex: 5;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Address = styled.address`
  font-style: normal;
  font-size: 12px;
  line-height: 1.5;
  color: white;
  margin-bottom: 16px;
`;

export const InfoDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  & > p {
    color: white;
  }
`;

export const List = styled.ul`
  flex: 5;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media ${({ theme }) => theme.device.mobile} {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 32px;

    // & > li:nth-last-child(1) {
    //   order: -1;
    //   grid-column: 1 / span 2;
    // }
  }
`;
// 언어 설정 주석
// grid-template-columns: repeat(5, 1fr);
export const ListItem = styled.li`
  max-width: 125px;
  width: 100%;
`;

export const ListTitle = styled.div`
  width: fit-content;

  &::after {
    content: '';
    display: block;
    width: 39%;
    height: 2px;
    margin-top: 4px;
    background-color: ${({ theme }) => hexToRGB(theme.colors.white, 0.33)};
  }
`;

export const SubList = styled.ul`
  margin-top: 24px;

  @media ${({ theme }) => theme.device.mobile} {
    margin-top: 16px;
  }
`;

export const SubListItem = styled.li`
  & > a {
    padding: 8px 0;
  }
`;

export const LangList = styled.ul`
  display: flex;
  gap: 16px;

  & > li {
    cursor: pointer;
  }
`;
